import { Component, OnInit } from '@angular/core';
import {AchatService} from '../../../../../../services/achat/achat.service';

@Component({
  selector: 'app-brouillon-fac-f',
  templateUrl: './brouillon-fac-f.component.html',
  styleUrls: ['./brouillon-fac-f.component.scss']
})
export class BrouillonFacFComponent implements OnInit {

    constructor(private dataService: AchatService) {}

    ngOnInit(): void {
        console.log('BrouillonCmdComponent initialized');
        this.dataService.filterFactureFournisseurByStatus('Brouillon');
    }

}
